<!--
 * @Date: 2020-08-21 17:39:25
 * @Author: MX
 * @LastEditTime: 2024-07-12 14:49:32
 * @Description: 注册
-->
<template>
  <div class="register">
    <video class="video-box" style="" @contextmenu.prevent id="bannerVideo" src="./login.mp4" disablePictureInPicture="true" controlslist="nodownload nofullscreen noremoteplayback" autoplay loop muted></video>
    <div class="register-box">
      <div class="iconBox">
        <i class="iconfont iconjitulogo_fanbai"></i>
      </div>
      <div class="title">
        极兔开放平台
      </div>
      <div class="form">
        <el-form
          ref="registerForm"
          :model="registerForm"
          :rules="rules"
          autocomplete="off"
          class="register-Form"
        >
          <el-form-item prop="account">
            <el-input
              placeholder="请输入账号名称"
              maxlength="40"
              v-model="registerForm.account"
            >
              <i
                slot="prefix"
                class="iconfont icondengluzhuce_yonghuming"
                :class="registerForm.account && 'red_color'"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              placeholder="请输入密码"
              :type="isShowPassword ? 'text' : 'password'"
              maxlength="18"
              v-model="registerForm.password"
            >
              <i
                slot="prefix"
                class="iconfont icondengluzhuce_mima"
                :class="registerForm.password && 'red_color'"
              ></i>
              <i
                slot="suffix"
                class="iconfont pointer"
                :class="[
                  isShowPassword
                    ? 'icondenglu_ico_mimakeshi'
                    : 'icondenglu_ico_mimayincang',
                ]"
                @click="toggleIcon"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input
              placeholder="请输入手机号"
              maxlength="11"
              v-model="registerForm.phone"
            >
              <i
                slot="prefix"
                class="iconfont icondengluzhuce_shouji"
                :class="registerForm.phone && 'red_color'"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="phoneCode" class="phoneCodeItem">
            <el-input
              placeholder="请输入手机验证码"
              maxlength="10"
              v-model="registerForm.phoneCode"
            >
              <i
                slot="prefix"
                class="iconfont icondengluzhuce_shurushoujiyanzhengma"
                :class="registerForm.phoneCode && 'red_color'"
              ></i>
            </el-input>
            <button
              class="sendcodeBtn commonBtn"
              @click.prevent="sendCode"
              :disabled="isSendCode"
            >
              <span v-if="!isSendCode">发送</span>
              <span v-else>{{ time }}秒</span>
            </button>
          </el-form-item>
          <div class="agreement">
            <el-checkbox
              v-model="isAgreement"
              @change="isAgreementChange"
            ></el-checkbox>
              <p style="padding-left: 10px;">
                我已阅读并接受<span class="agreement-click" @click="agreementClick">《极兔开放平台注册使用协议》</span>和<span class="agreement-click" @click="privacyClick">《隐私政策》</span>
              </p>
          </div>
          <button class="commonBtn registerBtn" @click.prevent="register" :disabled="!isAgreement">
            注 册
          </button>
          <!-- <div class="software-serve">
            <img src="@/assets/images/register/software-serve313.png" alt="">
          </div> -->
        </el-form>
      </div>
    </div>
    <!-- 遮罩层 -->
    <div class="mask" v-show="isShow1">
    </div>
    <!-- 弹出层-极兔开放平台注册使用协议 -->
    <div class="mask-agreement " v-if="isShow2">
      <h1 class="header">用户协议</h1>
      <div style="overflow: auto;">
        <articlesOfAgreement class="content" style="min-width: 1130px;"></articlesOfAgreement>
      </div>
      <div class="footer">
        <el-button type="primary" @click="close(2)">确 定</el-button>
      </div>
    </div>
    <!-- 弹出层-隐私政策 -->
    <div class="mask-privacy " v-if="isShow3">
      <h1 class="header">隐私政策-中国</h1>
      <div style="overflow: auto;">
        <privacyPolicy class="content" style="min-width: 1130px;"></privacyPolicy>
      </div>
      <div class="footer">
        <el-button :disabled="countDown > 0" type="primary" @click="close(3)"><span v-if="countDown > 0">({{ countDown }}s)</span> 确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import * as Api from '@/api'
import { RULES, VALIDATION } from '@/constants/rules'
import { RESPONSE_SUCCESS } from '@/constants'
import { mapActions } from 'vuex'
import articlesOfAgreement from "./components/ArticlesOfAgreement";
import privacyPolicy from "./components/PrivacyPolicy";
import { AESUtil } from '@/utils/'
export default {
  name: 'Register',
  components: {
    articlesOfAgreement,
    privacyPolicy
  },
  data() {
    return {
      registerForm: {
        account: '',
        password: '',
        phone: '',
        phoneCode: '',
        ctoken: '',
      },
      rules: {
        account: [RULES.account],
        password: [RULES.password, RULES.passwordNew],
        phone: [RULES.phone, RULES.checkPhone],
        phoneCode: [RULES.phoneCode],
      },
      imgSrc: '',
      name: '',
      isSendCode: false,
      time: 60,
      codeTimer: null,
      isShowPassword: false, //不显示
      phoneStatus: {
        isPass: false, //手机号是否可以发送验证码 需等待验证之后才可发送验证码
        isLoading: false,
        msg: '',
      },
      btnIsLoad: true, //注册按钮是否可以点击  防止多次提交
      isAgreement: false, // 是否勾选阅读单选框
      isShow1: false, // 遮罩层
      isShow2: false, // 协议-遮罩层
      isShow3: false, // 隐私协议-遮罩层
      captcha: '',
      apiType: '',
      countDown: 0,
      countDownTimer: 0
    }
  },
  created() {
    this.getImg()
  },
  mounted(){
    this.initTencentCaptcha();
  },
  destroyed() {
    clearInterval(this.codeTimer)
    clearInterval(this.countDownTimer)
  },
  methods: {
    ...mapActions(['LOGIN_INIT', 'LOGIN_INIT_APPID']),
    toggleIcon() {
      this.isShowPassword = !this.isShowPassword
      console.log(this.isShowPassword)
    },
    isAgreementChange(flag) {
      if (flag) {
        this.countDown = 15
        this.isShow1 = true
        this.isShow3 = true
        this.countDownTimer = setInterval(() => {
          if (this.countDown > 0) {
            this.countDown--
          } else {
            clearInterval(this.countDownTimer)
          }
        }, 1000)
      }
    },
    /**
     * @description 1.获取图形验证码
     */
    async getImg() {
      const res = await Api.getCaptcha()
      const { code, data } = res
      if (code === RESPONSE_SUCCESS) {
        this.imgSrc = data.img
        this.registerForm.ctoken = data.ctoken
      }
    },
    /**
     * @description 2.再次获取图形验证码
     */
    getImgAgain() {
      this.getImg()
    },
    /**
     * @description 3.发送验证码
     */
    async sendCode() {
      if (!this.registerForm.account) {
        return this.$message.warning('请输入账号名称')
      }
      if (!this.registerForm.phone) {
        return this.$message.warning('请输入手机号')
      }
      if (!VALIDATION.phoneNumber.value.test(this.registerForm.phone)) {
        return this.$message.warning('请输入正确的手机号')
      }
      this.apiType = 'sendCode'
      this.captcha.show()
    },
    async sendCodeApi(customParams) {
      const { phone, ctoken, account } = this.registerForm
      let httpParams = {
        phone,
        ctoken,
        type: 'register',
        account,
        ...customParams
      }
      await Api.sendMessage(httpParams).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.isSendCode = true
          clearInterval(this.codeTimer)
          this.codeTimer = setInterval(() => {
            this.time--
            if (this.time === 0) {
              this.isSendCode = false
              this.time = 60
            }
          }, 1000)
          this.$message.success('获取手机验证码成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = new window.TencentCaptcha('2033367267', this.tencentCaptchaCallback, { forceLang: 'zh-cn' });
      // 显示验证码
      // this.captcha.show()
    },
      // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res);
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        if (this.apiType === 'register') {
          // 注册
          this.registerApi(customParams)
        } else if (this.apiType === 'sendCode') {
          this.sendCodeApi(customParams)
        }
        return res
      }
      // 验证不成功
      return null
    },
    /**
     * @description 4.注册
     */
    register() {
      if (!this.btnIsLoad) {
        return
      }
      this.btnIsLoad = false
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.apiType = 'register'
          // this.captcha.show()
          this.registerApi({})
        } else {
          this.btnIsLoad = true
          console.log('error submit!!')
          return false
        }
      })
    },
    registerApi(customParams) {
      const { password } = this.registerForm;
      Api.register({...this.registerForm, password: AESUtil.aesEncrypt(password), ...customParams})
        .then((res) => {
          this.btnIsLoad = true
          if (res.code === RESPONSE_SUCCESS) {
            this.$message.success('注册成功')
            //注册完了直接登录
            this.LOGIN_INIT({ user: res.data, token: res.data.token })
            this.getAppList()
            this.$router.push({ path: '/' })
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.btnIsLoad = true
        })
    },
    /**
     * @description 应用列表数据
     */
    async getAppList() {
      const { code, data, msg } = await this.$API.appList()
      if (code === RESPONSE_SUCCESS) {
        this.LOGIN_INIT_APPID({ appId: data[0].id })
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * @description 点击协议
     */
    agreementClick() {
      this.isShow1 = true;
      this.isShow2 = true;
    },
    /**
     * @description 点击隐私政策
     */
    privacyClick() {
      this.isShow1 = true;
      this.isShow3 = true;
    },
    /**
     * @description 点击确认，关闭遮罩层
     */
    close(val) {
      this.isShow1 = false;
      if(val === 2) {
        this.isShow2 = false;
      }
      if(val === 3) {
        this.isShow3 = false;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.register {
  height: 100vh;
  min-width: 1200px;
  overflow: hidden;
  .video-box {
    position: absolute;
    width: auto;
    height: 100vh;
    top: 64px;
    left: 0;
  }
  .software-serve{
    margin: 60px auto;
    margin-bottom: 0;
    text-align: center;
  }
  //background: $theme-color url('../../assets/images/register/background.png')
  //  no-repeat 80px center;
  //background-size: 53%;
  position: relative;
  font-family: PingFang, PingFang-SC;
  .register-box {
    position: absolute;
    top: 50%;
    right: 160px;
    width: 520px;
    // height: 636px;
    background: rgba(255, 255, 255, 0.5); /* 设置背景颜色为白色，透明度为 0.5 */
    backdrop-filter: blur(10px); /* 模糊半径设为 10 像素 */
    border-radius: 8px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    padding: 50px 100px;
    box-sizing: border-box;
    transform: translateY(-50%);

    .iconBox {
      text-align: center;
      .iconjitulogo_fanbai {
        font-size: 31px;
        line-height: 31px;
        color: $theme-color;
      }
    }
    .title {
      width: 360px;
      font-size: 20px;
      text-align: center;
      color: $theme-color;
      line-height: 20px;
      letter-spacing: 40px;
      margin-top: 40px;
      font-weight: 600;
    }
    .form {
      margin-top: 30px;
      .iconfont {
        font-size: 20px;
        &.red_color {
          color: $theme-color;
        }
      }
      .registerBtn {
        width: 320px;
        height: 54px;
        background: $theme-color;
        font-size: 18px;
        background-image: linear-gradient(to right, #D31027 0%, #EA384D  51%, #D31027  100%);
        margin-top: 10px;
        padding: 15px 45px;
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: white;
        box-shadow: 0 0 20px #eee;
        border-radius: 10px;
        display: block;
      }
      .registerBtn:hover {
        background-position: right center !important; /* change the direction of the change here */
        color: #fff !important;
        text-decoration: none !important;
      }

      .codeFormItem {
        position: relative;
      }
      .codeFormItem-codeBox {
        position: absolute;
        width: 108px;
        height: 50px;
        background: #dad5d0;
        left: 160px;
        top: 0;
      }
      .codeFormItem-text {
        font-size: 14px;
        color: $theme-color;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
      }
    }
    .phoneCodeItem {
      position: relative;
      .sendcodeBtn {
        position: absolute;
        width: 60px;
        height: 32px;
        border-radius: 4px;
        font-size: 14px;
        right: 10px;
        top: 9px;
        border: 1px solid #c4c8cc;
      }
    }
    .agreement {
      display: flex;
      font-size: 13px;
      .agreement-click {
        cursor: pointer;
        color:$theme-color;
      }
    }
  }
  .mask {
    position:fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    background-color:#000;
    opacity:0.5;
    z-index: 200;
  }
  .mask-agreement {
    max-width: 1200px;
    width: 100%;
    max-height: 700px;
    background-color: #ffffff;
    position:fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    display: flex;
    flex: 1;
    flex-direction: column;
    z-index: 300;
    .header {
      width:100%;
      height: 100px;
      text-align: center;
      color: #ffffff;
      background-color:#333;
      opacity:0.5;
      padding: 20px 0;
    }
    .content {
      overflow: auto;
    }
    .footer {
      width:100%;
      text-align: center;
      padding: 20px 0;
      .el-button {
        width: 215px;
        height: 40px;
        border-radius: 4px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
  .mask-privacy {
    max-width: 1200px;
    // min-width: 1200px;
    width: 100%;
    max-height: 700px;
    background-color: #ffffff;
    position:fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    display: flex;
    flex: 1;
    flex-direction: column;
    z-index: 300;
    .header {
      width:100%;
      height: 100px;
      text-align: center;
      color: #ffffff;
      background-color:#333;
      opacity:0.5;
      padding: 20px 0;
    }
    .content {
      overflow: auto;
    }
    .footer {
      width:100%;
      padding: 20px 0;
      text-align: center;
      .el-button {
        width: 215px;
        height: 40px;
        border-radius: 4px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
}
.register::v-deep {
  .codeFormItem input {
    width: 146px;
  }
  .el-form-item__content {
    height: 50px;
    line-height: 50px;
    .el-input__inner {
      height: 50px;
      line-height: 50px;
    }
  }
  .el-input:focus-within .iconfont {
    color: $theme-color;
  }
  .el-input__prefix {
    left: 10px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 40px;
  }
  .el-input__suffix {
    right: 10px;
  }
}
@media only screen and (max-width: 1440px) {
  .register {
    .register-box {
      padding: 30px 100px 50px !important;
    }
    .title {
      margin-top: 20px !important;
    }
    .form {
      margin-top: 20px !important;
    }
  }
}
</style>
